import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination } from 'swiper/modules';

const helpers = window.BASE_HELPERS || {};
const { Mobile } = helpers;

const MODULE = document.querySelectorAll('[data-module="liderancas"]');

class Liderancas {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
            const swiperComponent = component.querySelector('.swiper');
            if (swiperComponent) this.initSwiper(swiperComponent);
        });
    }

    initSwiper(swiperComponent) {
        new Swiper(swiperComponent, {
            modules: [Pagination, Navigation],
            loop: false,
            slidesPerView: 1,
            spaceBetween: 12,
            on: {
                afterInit: (swiper) => {
                    if (Mobile.isMobile() && swiper.slides.length > 1) {
                        swiper.el.querySelector('.pagination').classList.add('active');
                    }

                    if (!Mobile.isMobile() && swiper.slides.length > 3) {
                        swiper.el.querySelector('.pagination').classList.add('active');
                    }
                }
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                }
            },
            navigation: {
                nextEl: swiperComponent.querySelector('.swiper-button-next'),
                prevEl: swiperComponent.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: swiperComponent.querySelector('.swiper-pagination'),
                clickable: true,
                type: 'bullets',
            },
        });
    }
}

(() => {
    if (MODULE) {
        new Liderancas();
    }
})();

export default Liderancas;
